import {
  withTranslation,
} from 'react-i18next';

import ShareButtonView from './ShareButtonView';

const TranslatedComponent = withTranslation()(ShareButtonView);

const Component = TranslatedComponent;

export default Component;
